import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AppSettings } from '../../../app.settings';
import { Settings } from '../../../app.settings.model';
import { listTransition } from 'src/app/theme/utils/app-animation';
import { MenuService } from '../../services/menu.service';

@Component({
	selector: 'app-breadcrumb',
	templateUrl: './breadcrumb.component.html',
	styleUrls: ['./breadcrumb.component.scss'],
	animations: [listTransition]
})
export class BreadcrumbComponent {

	@Input() breadcrumbs = [];

	settings: Settings;
	pageTitle: string;

	constructor(public appSettings: AppSettings, public router: Router, private readonly menuService: MenuService) {
		this.settings = this.appSettings.settings;
	}

	closeSubMenus(index: number) {
		if (this.settings.menu === AppSettings.MenuOrientation.VERTICAL && index === 0) {

			const homeUrl = this.menuService.getHomeUrl();

			this.menuService.expandActiveSubMenu(homeUrl, 'BreadcrumbComponent.closeSubMenus');
			this.router.navigate([homeUrl]);
		}
	}
}
